"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var validateEmail = function (email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var checkCyrillic = email.match(/[А-Яа-я]/i) ? false : true;
    return re.test(String(email).toLowerCase()) && checkCyrillic;
};
exports.default = validateEmail;
